module.exports = __webpack_public_path__ + "img/bank-disabled.68ab62fe.svg";